import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22layout.tsx%22,%22import%22:%22Noto_Sans_Thai%22,%22arguments%22:[{%22subsets%22:[%22thai%22],%22variable%22:%22--font-noto-sans-thai%22}],%22variableName%22:%22notoSansThai%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Noto Sans Thai', 'Noto Sans Thai Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
